import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49e6edb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "take-photo mb-5" }
const _hoisted_2 = { class: "image-display" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "camera-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay-cam" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "face-circle" })
], -1))
const _hoisted_7 = { class: "zoom-controls" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "zoom-value" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "capture-container" }
const _hoisted_12 = {
  ref: "canvasRef",
  style: {"display":"none"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.base64Photo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.base64Photo,
              alt: "Captured photo"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.getDefaultImage(),
              alt: "Uploaded Image"
            }, null, 8, _hoisted_4))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("video", {
            ref: "videoRef",
            autoplay: "",
            muted: "",
            playsinline: "",
            style: _normalizeStyle(_ctx.videoStyle)
          }, null, 4),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "zoom-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decreaseZoom && _ctx.decreaseZoom(...args))),
              disabled: _ctx.zoom <= _ctx.MIN_ZOOM
            }, " − ", 8, _hoisted_8),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.zoom) + "x ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "zoom-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.increaseZoom && _ctx.increaseZoom(...args))),
              disabled: _ctx.zoom >= _ctx.MAX_ZOOM
            }, " + ", 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.capturePhoto && _ctx.capturePhoto(...args))),
            class: _normalizeClass(["btn btn-file w-100", { disabled: !_ctx.cameraReady }])
          }, _toDisplayString(_ctx.i18n.t('button.take_photo')), 3)
        ])
      ]),
      _createElementVNode("canvas", _hoisted_12, null, 512)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger mt-3",
        key: error.$uid
      }, [
        _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
        _hoisted_13
      ]))
    }), 128))
  ], 64))
}